import { render, staticRenderFns } from "./AppointmentPayment.vue?vue&type=template&id=61ecb56a&"
import script from "./AppointmentPayment.vue?vue&type=script&lang=js&"
export * from "./AppointmentPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports